import { combineReducers } from "redux";
import auth from "./auth";
import settings from "./settings";
import printer from "./printer";
import dashboard from "./dashboard";
import design from "./design";
import log from "./log";
import ebarimt from "./ebarimt";
import satisfaction from "./satisfaction";
import printError from "./printError";
import template from "./template";
import admin from "./admin";
import tenant from "./tenant";
import partners from "./partners";
import { reducer as toastrReducer } from "react-redux-toastr";

export default combineReducers({
  auth,
  settings,
  printer,
  design,
  dashboard,
  log,
  ebarimt,
  satisfaction,
  printError,
  template,
  admin,
  tenant,
  partners,
  toastr: toastrReducer,
});
